import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/es'

import theme from "./config/theme";
import RouterApp from "./config/routes/Provider";
import ProviderI18n from "./config/i18n";
import SignalRListener from "./components/Alerts/SignalRListener";
import SignalRTest  from "../src/services/SignalRTest";


const App = () => {

  return (
    <ThemeProvider theme={theme}>
      <ProviderI18n>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <SignalRListener backend="server" />
          {/* <SignalRTest /> */}
          <RouterApp />
        </LocalizationProvider>
      </ProviderI18n>
    </ThemeProvider>
  );
}

export default App;
